import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Assigned Employees',
      type: 'details',
      content: {
        '{}': {
          fields: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@': 'fieldsForCurrentRecord',
                    },
                    null,
                  ],
                },
                {
                  '@': 'fieldsForCurrentRecord',
                },
              ],
              {
                '[]': [
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Mission',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value:
                        'Give leaders the confidence to pursue their boldest visions and the clarity to pursue them wisely.',
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Product Vision',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value:
                        "The leader's go-to source of business intelligence, delivering not just data, but the understanding that drives confident decision-making.",
                      readonly: true,
                    },
                  },
                ],
              },
            ],
          },
          columnCount: 4,
        },
      },
    },
  },
  variables: {
    currentEntityId: 'ent:!outcomes:!objective',
    currentRecordId: '?pro-hecvat',
  },
  subqueries: {
    fieldsForCurrentRecord: {
      filter: {
        and: [
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'currentEntityId',
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'currentRecordId',
              },
            ],
          },
        ],
      },
      target: 'dim::!outcomes',
      quantity: 1,
      selection: {
        '[]': [
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Responsible',
                      type: 'LIST',
                    },
                  },
                },
              },
              value: {
                '??': [
                  {
                    '@': 'responsible',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Consulted',
                      type: 'LIST',
                    },
                  },
                },
              },
              value: {
                '??': [
                  {
                    '@': 'consulted',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Informed',
                      type: 'LIST',
                    },
                  },
                },
              },
              value: {
                '??': [
                  {
                    '@': 'informed',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Accountable',
                      type: 'LIST',
                    },
                  },
                },
              },
              value: {
                '??': [
                  {
                    '@': 'accountable',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
              readonly: true,
            },
          },
        ],
      },
      subqueries: {
        informed: {
          ref: {
            attr: 'attr:ent#!outcome_assignees#!assignee:!personnel',
          },
          sort: {
            by: {
              '@.': '!name',
            },
          },
          using: 'assignees',
          filter: {
            some: [
              {
                '@': 'assignees',
              },
              {
                '@>': [
                  {
                    '@$': '$value',
                  },
                  'isInformed',
                ],
              },
            ],
          },
          target: 'ent:!personnel:!employee',
          selection: {
            '@.': '!name',
          },
        },
        assignees: {
          ref: {
            attr: 'attr:ent#!outcome_assignees#!assignee:!outcome',
          },
          target: 'ent:!outcome_assignees:!assignee',
          selection: {
            '{}': {
              isInformed: {
                '@.': '!is_informed',
              },
              isConsulted: {
                '@.': '!is_consulted',
              },
              isAccountable: {
                '@.': '!is_accountable',
              },
              isResponsible: {
                '@.': '!is_responsible',
              },
            },
          },
        },
        consulted: {
          ref: {
            attr: 'attr:ent#!outcome_assignees#!assignee:!personnel',
          },
          sort: {
            by: {
              '@.': '!name',
            },
          },
          using: 'assignees',
          filter: {
            some: [
              {
                '@': 'assignees',
              },
              {
                '@>': [
                  {
                    '@$': '$value',
                  },
                  'isConsulted',
                ],
              },
            ],
          },
          target: 'ent:!personnel:!employee',
          selection: {
            '@.': '!name',
          },
        },
        accountable: {
          ref: {
            attr: 'attr:ent#!outcome_assignees#!assignee:!personnel',
          },
          sort: {
            by: {
              '@.': '!name',
            },
          },
          using: 'assignees',
          filter: {
            some: [
              {
                '@': 'assignees',
              },
              {
                '@>': [
                  {
                    '@$': '$value',
                  },
                  'isAccountable',
                ],
              },
            ],
          },
          target: 'ent:!personnel:!employee',
          selection: {
            '@.': '!name',
          },
        },
        responsible: {
          ref: {
            attr: 'attr:ent#!outcome_assignees#!assignee:!personnel',
          },
          sort: {
            by: {
              '@.': '!name',
            },
          },
          using: 'assignees',
          filter: {
            some: [
              {
                '@': 'assignees',
              },
              {
                '@>': [
                  {
                    '@$': '$value',
                  },
                  'isResponsible',
                ],
              },
            ],
          },
          target: 'ent:!personnel:!employee',
          selection: {
            '@.': '!name',
          },
        },
      },
    },
  },
}
